import { Component, Input } from '@angular/core';

import { MediaConfig, ScrollingSizeConfig } from '@frontend/sports/common/client-config-data-access';

import { RedirectHelperService } from '../../navigation-core/redirect-helper.service';
import { LiveUrlParam, UrlHelperService } from '../../navigation-core/url-helper.service';
import { TabBarItem } from '../../tab-bar/tab-bar.models';
import { NavigationService } from '../navigation.service';

@Component({
    selector: 'ms-sport-navigation',
    templateUrl: './sport-navigation.component.html',
    styleUrl: './sport-navigation.component.scss',
})
export class SportNavigationComponent {
    @Input() model?: TabBarItem[];
    @Input() tracking?: string;

    constructor(
        public scrollConfig: ScrollingSizeConfig,
        private navigationService: NavigationService,
        private urlHelperService: UrlHelperService,
        public mediaConfig: MediaConfig,
        private redirectHelperService: RedirectHelperService,
    ) {}

    selected(id: string): void {
        let active = this.model?.find((item) => id === item.id.toString());

        if (active && !!active.url) {
            const activeUrl = active.url;
            this.redirectHelperService.goToPage(activeUrl, active.ignoreBrowserHistory);

            if (this.tracking && activeUrl) {
                const sport = active.id;
                const url = this.urlHelperService.getLastSegment(activeUrl);
                const param = sport > 0 ? sport.toString() : url;

                this.navigationService.tracking(param, this.tracking);
            }
        }
    }

    get activeId(): string {
        return this.model?.find((t) => t.active)?.id?.toString() ?? '';
    }

    count(tab: TabBarItem): number {
        return tab.count ?? 0;
    }

    isVideoStreamingEnabled(id: number): boolean {
        return this.mediaConfig.showVideoStreaming ? true : id !== LiveUrlParam.Video;
    }
}
